
export class Utils {
    /**
     * Generates a random UUID v4. It first tries to use the `crypto.randomUUID` method if it exists.
     *
     * @returns {string}
     */
    static generateUUID() {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            try {
                return crypto.randomUUID();
            } catch (e) {
                // Fallback if crypto.randomUUID fails
            }
        }

        // fallback: Math.random (less secure but works everywhere)
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    /** 
    * Splits an array into chunks of the specified size.
    * @param {Array} array - The array to split.
    * @param {number} size - The size of each chunk.
    * @returns {Array} - An array of chunks.
    */
    static chunkArray(array, size) {
        var chunks = [];
        for (var i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
        }
        return chunks;
    }

}
